import { render, staticRenderFns } from "./ResourceSelect.vue?vue&type=template&id=35bcde21&scoped=true&"
import script from "./ResourceSelect.vue?vue&type=script&lang=js&"
export * from "./ResourceSelect.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSelect.vue?vue&type=style&index=0&id=35bcde21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bcde21",
  null
  
)

export default component.exports